import React from 'react';
import UpdateForm from '../components/form/UpdateForm';
import Sidebar from '../components/sidebar/Sidebar';

const AddForm = () => {
    return (
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8">
    <Sidebar />
    <div className="lg:pl-[14rem] mt-[5.8125rem]">
      <UpdateForm />
    </div>
  </div>
    );
};

export default AddForm;